/**
 * 本文件中列出了各类 Push 消息的数据结构
 * NOTE: 消息Code，门店ID 这两个字段统一封装在 PushMessage 类中，不在此文件内体现
 */

/**
 * 新订单 push 中用于区分订单类型的标识
 */
enum PushOrderUserRole {
    /** 普通订单 */
    NORMAL = '-1',
    /** PHF拼单一起送主单 */
    PHF_MAIN = '1',
    /** PHF拼单一起送子单 */
    PHF_SUB = '2',
}

type NewOrderPushData = {
    /** 订单视图ID */
    wmOrderViewId: string;
    /** 订单类型 */
    user_role: PushOrderUserRole;
    /** 是否是预订单 */
    isPreOrder: boolean;
};

enum PushRefundType {
    /** 顾客正常的退款申请、申诉（新退单，需商家处理） */
    NORMAL = 0,
    /** 20分钟提醒退款 */
    REMINE_20_MINUTES = 1,
    /** 超预计送达时间30分钟极速退款（自动退单） */
    EXCEED_DELIVERY_TIME_30_MINUTES = 2,
    /** 接单一分钟内取消订单，自动退款（自动退单） */
    CANCEL_ORDER_IN_1_MINUTE = 3,
    /** 商家超时未处理退款请求，自动退款（自动退单） */
    TIMEOUT_AUTO_REFUND = 4,
    /** 极速退风控消息 */
    SPEED_REFUND_RISK_NOTICE = 5,
    /** 除一分钟之外的其他极速退 */
    OTHER = 6,
    /** 预订单自动取消 */
    PRE_ORDER_AUTO_CANCEL = 10,
    /** （下一次营业时触发）非营业时间预订单自动取消 */
    PRE_ORDER_AUTO_CANCEL_AT_REST = 8,
    /** 预订单部分退款 */
    PRE_ORDER_AUTO_PARTIAL_REFUND = 7,
    /** （下一次营业时触发）非营业时间预订单自动部分退款 */
    PRE_ORDER_AUTO_PARTIAL_REFUND_AT_REST = 9,
    /** 金额退 */
    AMOUNT_REFUND = 12,
}

type ApplyRefundPushData = {
    /** 退款类型 */
    refund_type: string;
    /** 订单流水号 */
    order_push_seq: number;
    /** 最后处理时间 */
    end_time: string;
    /** 订单ViewID */
    wmOrderViewId: string;
    showPoiName: boolean;
    message: string;
};

export { PushOrderUserRole, NewOrderPushData, ApplyRefundPushData, PushRefundType };
